import { OnboardingStep, OnboardingType } from '../types/onboarding';

/**
 * Step sequence for the onboarding flow
 */
const stepsSequence: Record<OnboardingType, OnboardingStep[]> = {
  npo: ['welcome', 'company-info-1', 'company-details-npo', 'payment'],
  company: ['welcome', 'company-info-1', 'company-details', 'payment'],
};

export default stepsSequence;
